
import React from 'react';
import NewSessionDialog from '../NewSessionDialog';
import StudentsListDialog from '../StudentsListDialog';
import AnnouncementDialog from '../AnnouncementDialog';

interface AdminDialogsProps {
  newSessionDialogOpen: boolean;
  setNewSessionDialogOpen: (open: boolean) => void;
  studentsListDialogOpen: boolean;
  setStudentsListDialogOpen: (open: boolean) => void;
  announcementDialogOpen: boolean;
  setAnnouncementDialogOpen: (open: boolean) => void;
  fetchTrainingSessions: () => void;
}

const AdminDialogs: React.FC<AdminDialogsProps> = ({
  newSessionDialogOpen,
  setNewSessionDialogOpen,
  studentsListDialogOpen,
  setStudentsListDialogOpen,
  announcementDialogOpen,
  setAnnouncementDialogOpen,
  fetchTrainingSessions
}) => {
  return (
    <>
      <NewSessionDialog 
        open={newSessionDialogOpen} 
        onOpenChange={setNewSessionDialogOpen}
        onSessionCreated={fetchTrainingSessions}
      />

      <StudentsListDialog
        open={studentsListDialogOpen}
        onOpenChange={setStudentsListDialogOpen}
      />

      <AnnouncementDialog
        open={announcementDialogOpen}
        onOpenChange={setAnnouncementDialogOpen}
      />
    </>
  );
};

export default AdminDialogs;
